import { animate, state, style, transition, trigger } from '@angular/animations';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { FilterValues } from 'app/core/interfaces/filtervalues.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { FlordersFilter } from '../../../core/interfaces/florders-filter.interface';
import { ValidatorService } from '../../../core/services/validator.service';
import { FlorderFilterComponent, FlorderFilterForm } from '../../florders/florder-filter/florder-filter.component';

export interface FlowFilterForm extends FlorderFilterForm {
  customers: FormControl<string[]>;
  flowTypes: FormControl<string[]>;
  clearingYes: FormControl<boolean>;
  clearingNo: FormControl<boolean>;
  handshakeDateFrom: FormControl<string>;
  handshakeDateTo: FormControl<string>;
  transferDateFrom: FormControl<string>;
  transferDateTo: FormControl<string>;
  flowStatuses: FormControl<string[]>;
  wholesalers: FormControl<string[]>;
}
@Component({
  selector: 'app-flow-filter',
  templateUrl: './flow-filter.component.html',
  styleUrls: ['../../florders/florder-filter/florder-filter.component.scss', './flow-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
  animations: [
    trigger('growInOut', [
      state('in', style({ height: '50px' })),
      transition('void => *', [style({ height: 0 }), animate(400)]),
      transition('* => void', [animate(400, style({ height: 0 }))]),
    ]),
  ],
})
export class FlowFilterComponent extends FlorderFilterComponent<FlowFilterForm> implements OnInit, OnChanges {
  @Input() filterValues: FilterValues;
  @Input() customers: Customer[];
  @Output() filterFlows = new EventEmitter<{ value: FlordersFilter; valid: boolean }>();

  constructor(formBuilder: FormBuilder, validatorService: ValidatorService, breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super(formBuilder, validatorService, breakpointObserver, cd);
  }

  protected getControlsConfig() {
    const controlsConfig = super.getControlsConfig();
    Object.assign(controlsConfig, {
      customers: [this.customers ? this.filter.customers || [] : null], // null = not a transporter, no multiple customer result, [] or non-empty array: filter on (multiple) customers
      flowTypes: [this.filter.flowTypes],
      clearingYes: [this.filter.clearingYes],
      clearingNo: [this.filter.clearingNo],
      handshakeDateFrom: [this.filter.handshakeDateFrom, [this.validatorService.datePatternValidator]],
      handshakeDateTo: [this.filter.handshakeDateTo, [this.validatorService.datePatternValidator, this.validatorService.dateSameOrAfter('handshakeDateFrom')]],
      transferDateFrom: [this.filter.transferDateFrom, [this.validatorService.datePatternValidator]],
      transferDateTo: [this.filter.transferDateTo, [this.validatorService.datePatternValidator, this.validatorService.dateSameOrAfter('transferDateFrom')]],
      flowStatuses: [this.filter.flowStatuses],
      wholesalers: [this.filter.wholesalers],
    });
    return controlsConfig;
  }

  filterClicked(): void {
    super.filterClicked(this.filterFlows);
  }
}
